<template>
    <van-popup v-model:show="showPicker" destroy-on-close round position="bottom" :style="{ height: '85%' }">
        <van-picker-group title="预约日期" :tabs="['开始日期', '结束日期']" @confirm="onConfirm">
            <van-date-picker v-model="startDate"   />
            <van-date-picker v-model="endDate"  />
        </van-picker-group>
    </van-popup>
</template>

<script setup>
import { ref, computed } from 'vue'

const emit = defineEmits(['update:modelValue', 'confirm'])

const showPicker = ref(false)
const startDate = ref()
const endDate = ref()

const openPicker = (initialValue = []) => {
    showPicker.value = true
}

const onConfirm = (values) => {
    const startDate = new Date(values[0].selectedValues.join('-'))
    const endDate = new Date(values[1].selectedValues.join('-'))
    const result = {
        startDate,
        endDate
    }
    showPicker.value = false
    emit('update:modelValue', result)
    emit('confirm', result)
}

defineExpose({
    openPicker
})
</script>
